/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Row,
  Col,
  Label,
  Card,
  Form,
  FormGroup,
  Input,
  CardTitle,
  CardText,
  Spinner,
} from "reactstrap";
import { Link, useParams } from "react-router-dom";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { IoAddSharp } from "react-icons/io5";
import { IoHelpSharp } from "react-icons/io5";
import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import { BsChevronRight } from "react-icons/bs";
import AddPointsModal from "../../../components/Modals/AddPointsModal";
import { Stepper } from "@zendeskgarden/react-accordions";
import swal from "sweetalert";
import "./Routes_Detail.scss";
import HelpModal from "../../../components/Modals/HelpModal";
import { useSelector, useDispatch } from "react-redux";
import {
  getUserRoutes,
  routeDetail,
  updateRouteDetail,
} from "../../../services/myRoute.service";
import ReportSuggestionModal from "../../../components/Modals/ReportSuggestionModal";
import axios from "axios";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ShareModal from "../../../components/Modals/ShareModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SweetAlert from "sweetalert-react";
import NoDataFound from "../../../components/NoDataFound/NoDataFound";
import {
  checkedCheckbox,
  hideLoader,
  showLoader,
} from "../../../utils/action/Action";
import { deductPoints, getUserPoints } from "../../../services/points.service";
import det_icon from "../../../assets/del_icon.svg";
import UserNotLoggedIn from "../../../components/UserNotLoggedIn/UserNotLoggedIn";
import { API_URL } from "../../../config/config";
import { GoHome } from "react-icons/go";
import { MdOutlineNavigateNext } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { IoNavigateSharp } from "react-icons/io5";
import { TiLocation } from "react-icons/ti";
import { MdDelete } from "react-icons/md";
import { size } from "lodash";
import delete_image from "../../../assets/rafiki.svg";
import marked_image_pop from "../../../assets/marked_pop.svg";
import marked_image from "../../../assets/marked_image.svg";
import failed_showPath from "../../../assets/failed_show_path.svg";

const containerStyle = {
  width: "100%",
  height: "440px",
  borderRadius: "20px",
};

const center = {
  lat: 47.433061,
  lng: 19.262404,
};

const options = {
  minZoom: 2,
  maxZoom: 17,
  gestureHandling: "greedy",
};

function Routes_Detail({ getPoints, isUserLoggedIn }) {
  const [dropdownOpen, setOpen] = useState(false);
  const [dropdownMenuOpen, setMenuOpen] = useState();
  const [showAddPointModal, setShowAddPointModal] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  let { selectedRouteName, routeId } = useParams();
  const [dropDownValue, setDropDownValue] = useState(selectedRouteName);
  const [route_Detail, setRoute_Detail] = useState([]);
  const [route_DetailAfterChecked, setRoute_DetailAfterChecked] = useState([]);
  const [showReportModal, setShowReportModal] = useState(false);
  const [pointName, setPointName] = useState(null);
  const [routeName, setRouteName] = useState(null);
  const [showListModal, setShowListModal] = useState(false);
  const [routesList, setRouteList] = useState([]);
  const [mkmID, setMkmId] = useState();
  const [showShareModal, setShowShareModal] = useState(false);
  const [confirmationAlert, setConfirmationAlert] = useState(false);
  const [link, setLink] = useState("");
  const [previousRoute, setPreviousRoute] = useState(null);
  const [PointAboveDetail, setPointAboveDeatil] = useState(null);
  const [addPointsDetail, setAddPointsDetail] = useState(null);
  const [optimizeRouteSpinner, setOptimizeRouteSpinner] = useState(false);
  const [refreshSpinner, setRefreshSpinner] = useState(false);
  const [items, setItems] = useState({});
  const [map, setMap] = useState(/**@type window?.google?.maps?.Map*/ (null));
  const [showPathSpinner, setShowPathSpinner] = useState(false);
  const [directionResponse, setDirectionResponse] = useState();
  const [startPoint, setStartPoints] = useState();
  const [endPoint, setEndPoints] = useState();
  const [showPathWayPoint, setShowPathWayPoints] = useState([]);
  const [totalDistance, setTotalDistance] = useState(0);
  const [tooltip, setTooltip] = useState({});
  const [tooltipOpenTotalDistance, setTooltipOpenTotalDistance] =
    useState(false);

  const [activeMarker, setActiveMarker] = useState(null);
  const [icon, setIcon] = useState("");

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const toggleTooltip = (targetName) => {
    if (!tooltip[targetName]) {
      setTooltip({
        ...tooltip,
        [targetName]: {
          tooltipOpen: true,
        },
      });
    } else {
      setTooltip({
        ...tooltip,
        [targetName]: {
          tooltipOpen: !tooltip[targetName]?.tooltipOpen,
        },
      });
    }
  };

  const toggleTotalDistance = () =>
    setTooltipOpenTotalDistance(!tooltipOpenTotalDistance);

  const isToolTipOpen = (targetName) => {
    return tooltip[targetName] ? tooltip[targetName]?.tooltipOpen : false;
  };
  const navigate = useNavigate();

  var arr = [];
  var wayPoints = [];

  const toggleAddPoint = () => setShowAddPointModal(!showAddPointModal);
  const toggleHelp = () => setShowHelpModal(!showHelpModal);

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );
  const check = useSelector((state) => state?.checkboxReducer?.viewCheckbox);
  const [checked, setChecked] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  useEffect(() => {
    if (isUserLoggedIn) {
      fetchUserRoutes();
    }
  }, []);

  useEffect(() => {
    setDropDownValue(selectedRouteName);
    {
      let match = false;
      if (check !== false) {
        if (check !== undefined) {
          check?.map((item) => {
            if (routeId === item?.id) {
              match = true;
              if (item?.viewCheckbox === true) {
                setChecked(true);
              } else {
                setChecked(false);
              }
            }
          });
        }
      }
      if (match === false) {
        setChecked(false);
      }
    }
    if (isUserLoggedIn) {
      fetchRouteDetails();
    }
  }, [routeId, selectedRouteName, dropDownValue, check]);

  const fetchUserRoutes = async () => {
    if (isUserLoggedIn) {
      dispatch(showLoader());
      try {
        const response = await getUserRoutes({
          userName: userName,
        });
        if (response && response?.status === 200) {
          setRouteList(response?.data?.data?.data);
          dispatch(hideLoader());
        }
      } catch (err) {
        setRouteList([]);
        dispatch(hideLoader());
      }
    }
  };

  const addPoints = (key) => {
    let data = [];
    let obj = [];

    if (check !== false) {
      data = route_DetailAfterChecked;
    } else {
      data = route_Detail;
    }
    obj?.push({
      route_id: routeId,
      route_name: dropDownValue,
      arr: data,
      key: key,
    });
    setAddPointsDetail(obj);
    setShowAddPointModal(true);
  };

  const addPointFromExploreNearBy = (poi, key) => {
    let data = [];
    let obj = [];

    if (check !== false) {
      data = route_DetailAfterChecked;
    } else {
      data = route_Detail;
    }
    obj?.push({
      route_id: routeId,
      route_name: dropDownValue,
      arr: data,
      key: key,
    });
    navigate(`/explore-near-by/${poi}`, {
      state: { from: "routeDetailExploreNearBy", data: obj },
    });
  };

  const addPointAbove = (mkmID, key) => {
    let data = [];
    let obj = [];

    if (check !== false) {
      data = route_DetailAfterChecked;
    } else {
      data = route_Detail;
    }
    let firstItem = data?.find((x) => x?.place?.mkmID === mkmID);
    let index = data?.indexOf(firstItem);
    obj?.push({
      index: index,
      route_id: routeId,
      route_name: dropDownValue,
      arr: data,
      key: key,
    });
    setPointAboveDeatil(obj);
    setShowAddPointModal(true);
  };

  const help = () => {
    setShowHelpModal(true);
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDzh8-GocyaUY-Y1vg21IVA5M0vx6RuqI8",
  });

  const deleteRoute = async (mkmID, title) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: `${title} will be removed from the route. Do you wish to continue?`,
      icon: delete_image,
      dangerMode: true,
      buttons: ["Cancel", "Yes"],
    });
    if (willDelete) {
      let new_routes = [];
      if (check !== false) {
        new_routes = setDeleteRouteRequestBody(route_DetailAfterChecked, mkmID);
      } else {
        new_routes = setDeleteRouteRequestBody(route_Detail, mkmID);
      }
      try {
        if (new_routes?.length === 0) {
          new_routes = [{}];
        }
        const response = await updateRouteDetail(new_routes, {
          userName: userName,
          routeID: routeId,
        });
        if (response && response?.status === 200) {
          swal("Deleted!", "Your Point has been deleted!", "success");
          fetchRouteDetails();
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "Oops.. something went wrong, try again !!!",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    }
  };

  const setDeleteRouteRequestBody = (data, mkmID) => {
    let firstItem = data?.find((x) => x?.place?.mkmID === mkmID);
    let index = data?.indexOf(firstItem);
    data?.splice(index, 1);
    let new_routes = [];
    new_routes = data?.map((item, i) => {
      return {
        mkmID: item?.place?.mkmID || item?.mkmID,
        orderNumber: i,
        visited: item?.visited,
      };
    });
    return new_routes;
  };

  const NavigateClick = (poi) => {
    const url = `https://www.google.com/maps/search/?api=1&query=${poi}`;
    window.open(url, "_blank");
  };

  const NavigateClickRoute = () => {
    // show the route on google maps
    let url = `https://www.google.com/maps/dir/`;
    console.log("path way points...", showPathWayPoint);
    showPathWayPoint?.forEach((item, i) => {
      url = url + `${item?.location?.lat},${item?.location?.lng}/`;
    });
    window.open(url, "_blank");
  };

  const changeValue = (e, id) => {
    clearMap();
    setDropDownValue(e?.target?.value);
    routeId = id;
    selectedRouteName = e?.target?.value;
    navigate(`/my-routes-detail/${routeId}/${selectedRouteName}`);
    // fetchRouteDetails();
  };

  const clearMap = () => {
    onLoad();
    setDirectionResponse();
    setStartPoints();
    setEndPoints();
    setShowPathWayPoints([]);
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const fetchRouteDetails = async () => {
    if (isUserLoggedIn) {
      try {
        dispatch(showLoader());
        if (routeId) {
          let obj = {
            userName: userName,
            routeID: routeId,
          };
          let response = await routeDetail(obj);
          if (response && response?.status === 200) {
            console.log("routes details....", response?.data?.data);
            setRoute_DetailAfterChecked(response?.data?.data);
            let match = false;
            let currentObj = {};
            if (check !== false) {
              check?.map((isChecked) => {
                if (isChecked?.id === routeId) {
                  match = true;
                  currentObj = isChecked;
                }
              });
            }
            if (match === true) {
              if (match === true && currentObj?.viewCheckbox === true) {
                let notVisited = [];
                response?.data?.data.map((item) => {
                  if (item?.visited === false) {
                    notVisited?.push(item);
                  }
                });
                if (notVisited?.length >= 2) {
                  var showPathWayPoints = [];

                  var startPoints = {
                    lat: Number(notVisited[0]?.place?.poi?.split(",")[0]),
                    lng: Number(notVisited[0]?.place?.poi?.split(",")[1]),
                  };
                  setStartPoints(startPoints);
                  var endPoints = {
                    lat: Number(
                      notVisited[notVisited?.length - 1]?.place?.poi?.split(
                        ","
                      )[0]
                    ),
                    lng: Number(
                      notVisited[notVisited?.length - 1]?.place?.poi?.split(
                        ","
                      )[1]
                    ),
                  };
                  setEndPoints(endPoints);
                  notVisited?.map((item) => {
                    var wayPoint = item?.place?.poi?.split(",");

                    var way = {
                      location: {
                        lat: Number(wayPoint[0]),
                        lng: Number(wayPoint[1]),
                      },
                      stopover: true,
                    };
                    showPathWayPoints?.push(way);
                  });
                  setShowPathWayPoints(showPathWayPoints);
                  setRoute_Detail(notVisited);
                  computeTotalDistance(notVisited);
                  dispatch(hideLoader());
                } else {
                  setRoute_Detail(notVisited);
                  computeTotalDistance();
                  setStartPoints();
                  setEndPoints();
                  setShowPathWayPoints([]);
                  dispatch(hideLoader());
                }
              } else {
                if (response?.data?.data?.length >= 2) {
                  showPathWayPoints = [];

                  startPoints = {
                    lat: Number(
                      response?.data?.data[0]?.place?.poi?.split(",")[0]
                    ),
                    lng: Number(
                      response?.data?.data[0]?.place?.poi?.split(",")[1]
                    ),
                  };
                  setStartPoints(startPoints);
                  endPoints = {
                    lat: Number(
                      response?.data?.data[
                        response?.data?.data?.length - 1
                      ]?.place?.poi?.split(",")[0]
                    ),
                    lng: Number(
                      response?.data?.data[
                        response?.data?.data?.length - 1
                      ]?.place?.poi?.split(",")[1]
                    ),
                  };
                  setEndPoints(endPoints);
                  response?.data?.data?.map((item) => {
                    var wayPoint = item?.place?.poi?.split(",");

                    var way = {
                      location: {
                        lat: Number(wayPoint[0]),
                        lng: Number(wayPoint[1]),
                      },
                      stopover: true,
                    };
                    showPathWayPoints?.push(way);
                  });
                  setShowPathWayPoints(showPathWayPoints);
                  setRoute_Detail(response?.data?.data);
                  computeTotalDistance(response?.data?.data);
                  dispatch(hideLoader());
                } else {
                  setRoute_Detail(response?.data?.data);
                  setStartPoints();
                  setEndPoints();
                  setShowPathWayPoints([]);
                  computeTotalDistance();
                  dispatch(hideLoader());
                  clearMap();
                }
              }
            } else {
              if (response?.data?.data?.length >= 2) {
                showPathWayPoints = [];

                startPoints = {
                  lat: Number(
                    response?.data?.data[0]?.place?.poi?.split(",")[0]
                  ),
                  lng: Number(
                    response?.data?.data[0]?.place?.poi?.split(",")[1]
                  ),
                };
                setStartPoints(startPoints);
                endPoints = {
                  lat: Number(
                    response?.data?.data[
                      response?.data?.data?.length - 1
                    ]?.place?.poi?.split(",")[0]
                  ),
                  lng: Number(
                    response?.data?.data[
                      response?.data?.data?.length - 1
                    ]?.place?.poi?.split(",")[1]
                  ),
                };
                setEndPoints(endPoints);
                response?.data?.data?.map((item) => {
                  var wayPoint = item?.place?.poi?.split(",");

                  var way = {
                    location: {
                      lat: Number(wayPoint[0]),
                      lng: Number(wayPoint[1]),
                    },
                    stopover: true,
                  };
                  showPathWayPoints?.push(way);
                });
                setShowPathWayPoints(showPathWayPoints);
                setRoute_Detail(response?.data?.data);
                computeTotalDistance(response?.data?.data);
                dispatch(hideLoader());
              } else {
                setRoute_Detail(response?.data?.data);
                setStartPoints();
                setEndPoints();
                setShowPathWayPoints([]);
                computeTotalDistance();
                dispatch(hideLoader());
                // clearMap();
              }
            }
          }
        }
      } catch {
        dispatch(hideLoader());
      }
    }
  };

  const markAsVisited = async (orderNumber, pointTitle) => {
    const isVisited = await swal({
      title: "Are you sure?",
      text: `All the places above ${pointTitle} in the route will be marked as Visited. Do you wish to continue?`,
      icon: marked_image_pop,
      dangerMode: true,
      buttons: ["Cancel", "Yes"],
    });
    if (isVisited) {
      let requestBody = [];
      if (check !== false) {
        requestBody = setMarkAsVisitedRequestBody(
          route_DetailAfterChecked,
          orderNumber
        );
      } else {
        requestBody = setMarkAsVisitedRequestBody(route_Detail, orderNumber);
      }
      let response = await updateRouteDetail(requestBody, {
        userName: userName,
        routeID: routeId,
      });
      if (response && response?.status === 200) {
        fetchRouteDetails();
        swal({
          title: "Marked as Visited!",
          text: "All your selected points are marked as Visited!",
          icon: marked_image,
        });
      }
    }
  };

  const markAsNotVisited = async (orderNumber, pointTitle) => {
    const isNotVisited = await swal({
      title: "Are you sure?",
      text: `All the places below ${pointTitle} in the route will be marked as Unvisited. Do you wish to continue?`,
      icon: marked_image_pop,
      dangerMode: true,
      buttons: ["Cancel", "Yes"],
    });
    if (isNotVisited) {
      let firstItem = route_Detail?.find((x) => x?.orderNumber === orderNumber);
      let index = route_Detail?.indexOf(firstItem);
      let requestBody = [];
      requestBody = route_Detail?.map((item, i) => {
        if (i >= index) {
          return {
            mkmID: item?.place?.mkmID,
            orderNumber: item?.orderNumber,
            visited: false,
          };
        } else {
          return {
            mkmID: item?.place?.mkmID,
            orderNumber: item?.orderNumber,
            visited: item?.visited,
          };
        }
      });
      let response = await updateRouteDetail(requestBody, {
        userName: userName,
        routeID: routeId,
      });
      if (response && response?.status === 200) {
        fetchRouteDetails();
        swal({
          title: "Marked as Not Visited!",
          text: "All your selected points are marked as not Visited!",
          icon: marked_image,
        });
      }
    }
  };

  const setMarkAsVisitedRequestBody = (data, orderNumber) => {
    let firstItem = data?.find((x) => x?.orderNumber === orderNumber);
    let index = data?.indexOf(firstItem);
    let requestBody = [];
    requestBody = data?.map((item, i) => {
      if (i <= index) {
        return {
          mkmID: item?.place?.mkmID,
          orderNumber: item?.orderNumber,
          visited: true,
        };
      } else {
        return {
          mkmID: item?.place?.mkmID,
          orderNumber: item?.orderNumber,
          visited: false,
        };
      }
    });

    return requestBody;
  };

  const optimizeRoute = async () => {
    if (isUserLoggedIn) {
      setOptimizeRouteSpinner(true);
      let totalPoints = await getUserPoints({
        userName: userName,
      });
      if (totalPoints?.data?.data?.userPoints === 0) {
        setOptimizeRouteSpinner(false);
        const notPoints = await swal({
          title: "Failed to Show Path",
          text: "Seems like you do not have enough points in your account.",
          icon: failed_showPath,
          buttons: ["Cancel", "Buy Points"],
        });
        if (notPoints) {
          navigate("/points");
        }
      } else {
        setOptimizeRouteSpinner(true);
        let data = {
          userName: userName,
          devicePlatform:
            navigator?.userAgent?.indexOf("Win") !== -1
              ? "WINDOWS"
              : navigator?.userAgent?.indexOf("Android") !== -1
              ? "ANDROID"
              : navigator?.userAgent?.indexOf("like Mac") !== -1
              ? "IOS"
              : navigator?.userAgent?.indexOf("Linux") !== -1
              ? "LINUX"
              : navigator?.userAgent?.indexOf("Mac") !== -1
              ? "MACINTOSH"
              : "",
          pointsUsed: 1,
        };
        await deductPoints(data);
        getPoints();

        if (route_Detail?.length > 3) {
          let mapUrl = `${API_URL}/api/opt/ggl?`;
          if (route_Detail?.length > 0) {
            let firstItem = route_Detail?.find((v) => v?.visited !== true);
            let origin = firstItem?.place?.poi;
            if (route_Detail?.length !== 1) {
              let dest = route_Detail[route_Detail?.length - 1]?.place?.poi;
              var output = route_Detail?.filter(
                (v, i) => i !== route_Detail?.length - 1 && v?.visited !== true
              );
              let excludeStartPoint = output?.filter((n, j) => j !== 0);
              let waypoints = "";
              for (let i = 0; i < excludeStartPoint?.length; i++) {
                waypoints = waypoints + excludeStartPoint[i]?.place?.poi;
                if (i !== excludeStartPoint?.length - 1) {
                  waypoints = waypoints + "|";
                }
              }
              mapUrl =
                mapUrl +
                "origin=" +
                origin +
                "&" +
                "destination=" +
                dest +
                "&" +
                "waypoints=" +
                waypoints;
            }
          }
          let waypointOrder;
          axios({
            method: "GET",
            url: mapUrl,
          }).then(async (res) => {
            if (res && res?.status === 200) {
              waypointOrder = res?.data?.routes[0]?.waypoint_order;
              let pointsClone = [...route_Detail];
              let visited = pointsClone?.filter((dt) => {
                return dt?.visited === true;
              });
              if (visited?.length > 0) {
                pointsClone = pointsClone?.filter((itm) => {
                  return itm?.visited !== true;
                });
                var firstPoint = pointsClone[0];
                pointsClone?.shift();
              } else {
                pointsClone?.shift();
              }
              pointsClone?.pop();
              var updatedPoints = [];
              if (visited?.length > 0) {
                for (let k = 0; k < visited?.length; k++) {
                  updatedPoints?.push(visited[k]);
                }
                updatedPoints?.push(firstPoint);
              } else {
                updatedPoints?.push(route_Detail[0]);
              }
              if (waypointOrder?.length === pointsClone?.length) {
                waypointOrder?.map((wayPointValue) => {
                  let findObject = pointsClone?.find((routevalue, index) => {
                    return wayPointValue === index;
                  });
                  updatedPoints?.push(findObject);
                });
              }
              updatedPoints?.push(route_Detail[route_Detail?.length - 1]);
              setRoute_Detail(updatedPoints);
              let requestBody = [];
              requestBody = updatedPoints?.map((item, i) => {
                return {
                  mkmID: item?.place?.mkmID,
                  orderNumber: i,
                  visited: item?.visited,
                };
              });
              let response = await updateRouteDetail(requestBody, {
                userName: userName,
                routeID: routeId,
              });
              if (response && response?.status === 200) {
                setOptimizeRouteSpinner(false);
                fetchRouteDetails();
                swal(
                  "Route Optimized!",
                  "Your route is optimized successfully!",
                  "success"
                );
              }
            }
          });
        } else {
          toast.info("You should have more than 3 points added in route.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setOptimizeRouteSpinner(false);
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to optimize routes?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const isDiasabled = () => {
    if (optimizeRouteSpinner === true) {
      return true;
    }
  };

  const onLoad = useCallback(async function callback(map) {
    var wayPoint;
    var startPoints;
    var endPoints;
    var showPathWayPoints = [];
    const bounds = new window.google.maps.LatLngBounds();
    if (isUserLoggedIn) {
      try {
        if (routeId) {
          let obj = {
            userName: userName,
            routeID: routeId,
          };
          let response = await routeDetail(obj);
          if (response && response?.status === 200) {
            let match = false;
            let currentObj = {};
            if (check !== false) {
              check?.map((isChecked) => {
                if (isChecked?.id === routeId) {
                  match = true;
                  currentObj = isChecked;
                }
              });
            }
            if (match === true) {
              if (match === true && currentObj?.viewCheckbox === true) {
                let notVisited = [];
                response?.data?.data.map((item) => {
                  if (item?.visited === false) {
                    notVisited?.push(item);
                  }
                });
                if (notVisited?.length >= 1) {
                  startPoints = {
                    lat: Number(notVisited[0]?.place?.poi?.split(",")[0]),
                    lng: Number(notVisited[0]?.place?.poi?.split(",")[1]),
                  };
                  setStartPoints(startPoints);
                  endPoints = {
                    lat: Number(
                      notVisited[notVisited?.length - 1]?.place?.poi?.split(
                        ","
                      )[0]
                    ),
                    lng: Number(
                      notVisited[notVisited?.length - 1]?.place?.poi?.split(
                        ","
                      )[1]
                    ),
                  };
                  setEndPoints(endPoints);
                  notVisited?.map((item) => {
                    wayPoint = item?.place?.poi?.split(",");

                    var way = {
                      location: {
                        lat: Number(wayPoint[0]),
                        lng: Number(wayPoint[1]),
                      },
                      stopover: true,
                    };
                    showPathWayPoints?.push(way);
                    bounds?.extend({
                      lat: Number(wayPoint[0]),
                      lng: Number(wayPoint[1]),
                    });
                  });
                  setShowPathWayPoints(showPathWayPoints);
                  setRoute_Detail(notVisited);
                  computeTotalDistance(notVisited);
                } else {
                  setRoute_Detail(notVisited);
                  computeTotalDistance();
                  setStartPoints();
                  setEndPoints();
                  setShowPathWayPoints([]);
                }
              } else {
                if (response?.data?.data?.length >= 1) {
                  startPoints = {
                    lat: Number(
                      response?.data?.data[0]?.place?.poi?.split(",")[0]
                    ),
                    lng: Number(
                      response?.data?.data[0]?.place?.poi?.split(",")[1]
                    ),
                  };
                  setStartPoints(startPoints);
                  endPoints = {
                    lat: Number(
                      response?.data?.data[
                        response?.data?.data?.length - 1
                      ]?.place?.poi?.split(",")[0]
                    ),
                    lng: Number(
                      response?.data?.data[
                        response?.data?.data?.length - 1
                      ]?.place?.poi?.split(",")[1]
                    ),
                  };
                  setEndPoints(endPoints);
                  response?.data?.data?.map((item) => {
                    wayPoint = item?.place?.poi?.split(",");

                    var way = {
                      location: {
                        lat: Number(wayPoint[0]),
                        lng: Number(wayPoint[1]),
                      },
                      stopover: true,
                    };
                    showPathWayPoints?.push(way);
                    bounds?.extend({
                      lat: Number(wayPoint[0]),
                      lng: Number(wayPoint[1]),
                    });
                  });
                  setShowPathWayPoints(showPathWayPoints);
                  setRoute_Detail(response?.data?.data);
                  computeTotalDistance(response?.data?.data);
                } else {
                  setRoute_Detail(response?.data?.data);
                  computeTotalDistance();
                  setStartPoints();
                  setEndPoints();
                  setShowPathWayPoints([]);
                }
              }
            } else {
              if (response?.data?.data?.length >= 1) {
                startPoints = {
                  lat: Number(
                    response?.data?.data[0]?.place?.poi?.split(",")[0]
                  ),
                  lng: Number(
                    response?.data?.data[0]?.place?.poi?.split(",")[1]
                  ),
                };
                setStartPoints(startPoints);

                endPoints = {
                  lat: Number(
                    response?.data?.data[
                      response?.data?.data?.length - 1
                    ]?.place?.poi?.split(",")[0]
                  ),
                  lng: Number(
                    response?.data?.data[
                      response?.data?.data?.length - 1
                    ]?.place?.poi?.split(",")[1]
                  ),
                };
                setEndPoints(endPoints);

                response?.data?.data?.map((item) => {
                  wayPoint = item?.place?.poi?.split(",");

                  var way = {
                    location: {
                      lat: Number(wayPoint[0]),
                      lng: Number(wayPoint[1]),
                    },
                    stopover: true,
                  };
                  showPathWayPoints?.push(way);
                  bounds?.extend({
                    lat: Number(wayPoint[0]),
                    lng: Number(wayPoint[1]),
                  });
                });
                setShowPathWayPoints(showPathWayPoints);
                setRoute_Detail(response?.data?.data);
                computeTotalDistance(response?.data?.data);
              } else {
                setRoute_Detail(response?.data?.data);
                computeTotalDistance();
                setStartPoints();
                setEndPoints();
                setShowPathWayPoints([]);
              }
            }
          }
        }
      } catch {}
    }
    if (startPoints !== undefined && endPoints !== undefined) {
      bounds?.extend(startPoints);
      bounds?.extend(endPoints);
    } else if (startPoints !== undefined && endPoints === undefined) {
      bounds?.extend(startPoints);
    } else if (endPoints !== undefined && startPoints === undefined) {
      bounds?.extend(endPoints);
    } else {
      bounds?.extend(center);
    }
    map?.fitBounds(bounds);
    // Set the desired zoom level
    map.setZoom(12);
    // map?.setZoom(10)
    setMap(map);
  }, []);

  const showPath = async () => {
    if (isUserLoggedIn) {
      setShowPathSpinner(true);
      let totalPoints = await getUserPoints({
        userName: userName,
      });
      if (totalPoints?.data?.data?.userPoints === 0) {
        setShowPathSpinner(false);
        const notPoints = await swal({
          title: "Failed to Show Path",
          text: "Seems like you do not have enough points in your account.",
          icon: failed_showPath,
          buttons: ["Cancel", "Buy Points"],
        });
        if (notPoints) {
          navigate("/points");
        }
      } else {
        setShowPathSpinner(true);
        let data = {
          userName: userName,
          devicePlatform:
            navigator?.userAgent?.indexOf("Win") !== -1
              ? "WINDOWS"
              : navigator?.userAgent?.indexOf("Android") !== -1
              ? "ANDROID"
              : navigator?.userAgent?.indexOf("like Mac") !== -1
              ? "IOS"
              : navigator?.userAgent?.indexOf("Linux") !== -1
              ? "LINUX"
              : navigator?.userAgent?.indexOf("Mac") !== -1
              ? "MACINTOSH"
              : "",
          pointsUsed: 1,
        };
        await deductPoints(data);
        getPoints();
        const directionsService = new window.google.maps.DirectionsService();

        let start = startPoint;
        let end = endPoint;
        let wayPointsShowPath = showPathWayPoint;

        let request = {
          origin: start,
          waypoints: wayPointsShowPath,
          destination: end,
          optimizeWaypoints: true,
          travelMode: "DRIVING",
        };
        if (start !== undefined && end !== undefined) {
          directionsService?.route(request, async function (result, status) {
            if (status === "OK") {
              setDirectionResponse(result);
              setMap(map);
              setShowPathSpinner(false);
            } else {
              toast.error("No paths found.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
              setShowPathSpinner(false);
            }
          });
        } else if (start !== undefined && end === undefined) {
          toast.info("Please add more than 2 Points in this Routes.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setShowPathSpinner(false);
        } else if (end !== undefined && start === undefined) {
          toast.info("Please add more than 2 Points in this Routes.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setShowPathSpinner(false);
        } else {
          toast.info("Please add more than 2 Points in this Routes.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setShowPathSpinner(false);
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to show path?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  function computeTotalDistance(result) {
    let data = result;
    var totalDist = 0;

    for (var i = 0; i < data?.length; i++) {
      if (data[i]?.visited !== true) {
        if (data[i]?.distance_value !== undefined) {
          totalDist += data[i]?.distance_value;
        }
      }
    }
    totalDist = (totalDist / 1000).toFixed(2);
    setTotalDistance(totalDist);
  }

  const isShowPathDisabled = () => {
    if (showPathSpinner === true) {
      return true;
    }
  };

  const isRefreshDisabled = () => {
    if (refreshSpinner === true) {
      return true;
    }
  };

  function checkVal(array, value) {
    return array?.some(function (entry) {
      if (Array.isArray(entry)) {
        return checkVal(entry, value);
      }
      return entry?.id === value;
    });
  }

  const showNotVisited = (e) => {
    if (check !== undefined) {
      arr = check;
    }
    let obj = {
      viewCheckbox: e?.target?.checked,
      id: routeId,
    };
    if (checkVal(arr, obj?.id) === true) {
      arr?.map((item, index) => {
        if (item?.id === obj?.id) {
          arr[index] = obj;
        }
      });
    } else {
      arr?.push(obj);
    }
    dispatch(checkedCheckbox(arr));
    setChecked(obj?.viewCheckbox);
    fetchRouteDetails();
  };

  const handleOnDragEnd = async (result) => {
    if (!result.destination) return;
    let data = [];
    let requestBody = [];
    let source = result?.source?.index;
    let destination = result?.destination?.index;
    if (check !== false) {
      data = route_DetailAfterChecked;
      source = source + (route_DetailAfterChecked.length - route_Detail.length);
      destination =
        destination + (route_DetailAfterChecked.length - route_Detail.length);
    } else {
      data = route_Detail;
    }

    const items = data;
    const [reorderedItem] = items?.splice(source, 1);
    items?.splice(destination, 0, reorderedItem);
    setRoute_Detail(items);

    requestBody = items?.map((item, i) => {
      return {
        mkmID: item?.place?.mkmID || item?.mkmID,
        orderNumber: i,
        visited: item?.visited,
      };
    });
    try {
      await updateRouteDetail(requestBody, {
        userName: userName,
        routeID: Number(routeId),
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Oops.. something went wrong, try again !!!",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        }
      );
    }
    fetchRouteDetails();
  };

  const getPreviousRoute = (index) => {
    let previous_route = [];
    for (let i = 0; i <= index; i++) {
      if (i === index || i === index - 1) {
        previous_route?.push(route_Detail[i]);
      } else {
        continue;
      }
    }
    setPreviousRoute(previous_route);
  };

  const viewDetails = (a, b, poi) => {
    let data = [];
    let obj = [];

    if (check !== false) {
      data = route_DetailAfterChecked;
    } else {
      data = route_Detail;
    }
    obj?.push({
      route_id: routeId,
      route_name: dropDownValue,
      arr: data,
      key: "routeDetail",
    });
    if (a !== undefined && b === undefined) {
      navigate(`/category-detail/?tzadikimId=${a}&cor=${poi}`, {
        state: { from: "routeDetail", data: obj },
      });
    } else if (a === undefined && b !== undefined) {
      navigate(`/category-detail/?MkmId=${b}&cor=${poi}`, {
        state: { from: "routeDetail", data: obj },
      });
    }
  };

  const previousRouteChange = () => {
    let data = [];
    let obj = [];

    if (check !== false) {
      data = route_DetailAfterChecked;
    } else {
      data = route_Detail;
    }
    obj?.push({
      route_id: routeId,
      route_name: dropDownValue,
      arr: data,
      key: "alongPreviousPoint",
    });
    navigate("/along-route-previous-point", {
      state: {
        from: "alongPreviousPoint",
        data: previousRoute,
        detailData: obj,
      },
    });
  };

  const refresh = async () => {
    if (isUserLoggedIn) {
      setRefreshSpinner(true);
      let route_data = route_Detail;
      let totalPoints = await getUserPoints({
        userName: userName,
      });
      if (totalPoints?.data?.data?.userPoints === 0) {
        setRefreshSpinner(false);
        const notPoints = await swal({
          title: "Failed to Show Path",
          text: "Seems like you do not have enough points in your account.",
          icon: failed_showPath,
          buttons: ["Cancel", "Buy Points"],
        });
        if (notPoints) {
          navigate("/points");
        }
      } else {
        setRefreshSpinner(true);
        if (startPoint !== undefined || endPoint !== undefined) {
          setRefreshSpinner(true);
          const directionsService = new window.google.maps.DirectionsService();

          let start = startPoint;
          let end = endPoint;
          let wayPointsShowPath = showPathWayPoint;

          let request = {
            origin: start,
            waypoints: wayPointsShowPath,
            destination: end,
            optimizeWaypoints: true,
            travelMode: "DRIVING",
          };
          directionsService.route(request, async function (result, status) {
            if (status === "OK") {
              let data = {
                userName: userName,
                devicePlatform:
                  navigator?.userAgent?.indexOf("Win") !== -1
                    ? "WINDOWS"
                    : navigator?.userAgent?.indexOf("Android") !== -1
                    ? "ANDROID"
                    : navigator?.userAgent?.indexOf("like Mac") !== -1
                    ? "IOS"
                    : navigator?.userAgent?.indexOf("Linux") !== -1
                    ? "LINUX"
                    : navigator?.userAgent?.indexOf("Mac") !== -1
                    ? "MACINTOSH"
                    : "",
                pointsUsed: 1,
              };
              await deductPoints(data);
              getPoints();
              let arr = route_data;
              let index = 1;
              result?.routes[0]?.legs?.map((item) => {
                arr[index].distance = item?.distance?.text;
                arr[index].duration = item?.duration?.text;
                arr[index].distance_value = item?.distance?.value;
                arr[index].duration_value = item?.duration?.value;
                index++;
              });
              arr?.map((item) => {
                if (item?.visited === true) {
                  delete item?.distance;
                  delete item?.duration;
                }
              });
              setRoute_Detail(arr);
              computeTotalDistance(arr);
              setRefreshSpinner(false);
            } else {
              setRefreshSpinner(false);
              toast.error("No Distance found.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
            }
          });
        } else {
          toast.info(
            "Please add more than 2 Points in this Route.",
            {
              position: toast.POSITION.TOP_RIGHT,
            },
            setTimeout(() => {
              setRefreshSpinner(false);
            }, 3000)
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to get an accurate mesaurement?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  return (
    <div className="main_section myroutes_detail">
      <Container>
        <SweetAlert
          show={confirmationAlert}
          title="Demo"
          text="SweetAlert in React"
          onConfirm={() => this.setState({ show: false })}
        />
        <ReportSuggestionModal
          showReportModal={showReportModal}
          setShowReportModal={setShowReportModal}
          showListModal={showListModal}
          setShowListModal={setShowListModal}
          setRouteName={setRouteName}
          routeName={routeName}
          pointName={pointName}
          mkmID={mkmID}
        />
        <ShareModal
          showShareModal={showShareModal}
          setShowShareModal={setShowShareModal}
          link={link}
          setLink={setLink}
        />
        <AddPointsModal
          showAddPointModal={showAddPointModal}
          toggleAddPoint={toggleAddPoint}
          PointAboveDetail={PointAboveDetail}
          addPointsDetail={addPointsDetail}
        />
        <HelpModal
          showHelpModal={showHelpModal}
          setShowHelpModal={setShowHelpModal}
          toggleHelp={toggleHelp}
        />
        {/* <SearchBar /> */}
        <div className="breadcrumb_section">
          <Container>
            <Breadcrumb className="breadcrumb">
              <BreadcrumbItem>
                <Link to="/" className="breadcrumb_item1">
                  <GoHome style={{ width: "23px", height: "23px" }} />
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to="/my-routes" className="breadcrumb_item1">
                  My Routes
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <Link to="#" className="breadcrumb_item2">
                  Details
                </Link>
              </BreadcrumbItem>
            </Breadcrumb>
          </Container>
        </div>
        <div className="myroutes_detail_section">
          <Container fluid>
            <div className="details_header_top">
              <h4>My Routes</h4>
              <div className="header_inner">
                <div className="button_section">
                  <Button
                    onClick={() => optimizeRoute()}
                    disabled={isDiasabled()}
                    className="optimize_route"
                  >
                    {optimizeRouteSpinner === true ? (
                      <Spinner size="sm"></Spinner>
                    ) : (
                      <>
                        Optimize My Route
                        <FaArrowRight />
                      </>
                    )}
                  </Button>

                  <Button
                    className="refresh"
                    onClick={() => NavigateClickRoute()}
                  >
                    show in google maps
                  </Button>
                </div>
              </div>
            </div>

            <div className="b_rdai">
              <div className="left_side_card">
                <div className="details_header">
                  <Form className="form">
                    <FormGroup check>
                      <Input
                        checked={checked}
                        type="checkbox"
                        onChange={(e) => showNotVisited(e)}
                      />{" "}
                      <Label check>Show only not visited</Label>
                    </FormGroup>
                  </Form>
                  <div className="buttons">
                    <Dropdown
                      className="myroute_dropdown"
                      toggle={() => {
                        setOpen(!dropdownOpen);
                      }}
                      isOpen={dropdownOpen}
                    >
                      {isUserLoggedIn ? (
                        <>
                          <DropdownToggle caret>{dropDownValue}</DropdownToggle>

                          <DropdownMenu>
                            {routesList?.map((item) => {
                              return (
                                <DropdownItem
                                  style={{
                                    overflow: "hidden",
                                    display: "flex",
                                    flexWrap: "wrap",
                                  }}
                                  key={item?.routeID}
                                  onClick={(e) => changeValue(e, item?.routeID)}
                                  value={item?.routeName}
                                >
                                  {item?.routeName?.substring(0, 20)}
                                  <br /> {item?.routeName?.substring(20, 40)}
                                  <br /> {item?.routeName?.substring(40, 80)}
                                </DropdownItem>
                              );
                            })}
                          </DropdownMenu>
                        </>
                      ) : (
                        <DropdownToggle caret>N/A</DropdownToggle>
                      )}
                    </Dropdown>
                    <Button
                      className="add_points"
                      onClick={() => addPoints("addPoints")}
                    >
                      <IoAddSharp size={18} />
                      <span> Add Points</span>
                    </Button>
                    <Button className="help_button" onClick={help}>
                      <IoHelpSharp size={18} className="help_icon" />
                      <span>Help</span>
                    </Button>
                  </div>
                </div>
                <Col
                  md="12"
                  lg="6"
                  className="pe-0 b-r-radi"
                  style={{ width: "100%" }}
                >
                  <div className="map">
                    <div
                      className="map_header"
                      style={{ width: "100%", borderRadius: "20px" }}
                    >
                      {isLoaded ? (
                        <GoogleMap
                          zoom={2}
                          mapContainerStyle={containerStyle}
                          options={options}
                          onLoad={onLoad}
                        >
                          {isUserLoggedIn && (
                            <>
                              <Marker
                                key={route_Detail[0]?.id}
                                position={{
                                  lat: Number(
                                    route_Detail[0]?.place?.poi?.split(",")[0]
                                  ),
                                  lng: Number(
                                    route_Detail[0]?.place?.poi?.split(",")[1]
                                  ),
                                }}
                                icon="http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                              />
                              <Marker
                                key={route_Detail[route_Detail?.length - 1]}
                                position={{
                                  lat: Number(
                                    route_Detail[
                                      route_Detail?.length - 1
                                    ]?.place?.poi?.split(",")[0]
                                  ),
                                  lng: Number(
                                    route_Detail[
                                      route_Detail?.length - 1
                                    ]?.place?.poi?.split(",")[1]
                                  ),
                                }}
                                icon="http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                              ></Marker>
                              {route_Detail?.map((item, index) => (
                                <div key={index}>
                                  {(wayPoints = item?.place?.poi?.split(","))}
                                  <Marker
                                    position={{
                                      lat: Number(wayPoints[0]),
                                      lng: Number(wayPoints[1]),
                                    }}
                                    // icon={{
                                    //     url: item?.place?.categotyID === 1
                                    //         ? "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                    //         : item?.place?.categotyID === 10
                                    //             ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                                    //             : item?.place?.categotyID === 5
                                    //                 ? "http://maps.google.com/mapfiles/ms/icons/purple-dot.png"
                                    //                 : item?.place?.categotyID === 4
                                    //                     ? require('../../../assets/darkpurple.png')
                                    //                     : item?.place?.categotyID === 2
                                    //                         ? "http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png"
                                    //                         : item?.place?.categotyID === 7
                                    //                             ? "http://maps.google.com/mapfiles/ms/icons/pink-dot.png"
                                    //                             : item?.place?.categotyID === 9
                                    //                                 ? require('../../../assets/gray.png')
                                    //                                 : item?.place?.categotyID === 12
                                    //                                     ? require('../../../assets/darkblue.png')
                                    //                                     : require('../../../assets/lightpink.png')
                                    // }}

                                    onLoad={(marker) => {
                                      const customIcon = (opts) =>
                                        Object.assign(
                                          {
                                            path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z",
                                            fillColor: "#34495e",
                                            fillOpacity: 1,
                                            strokeColor: "teal",
                                            strokeWeight: 2,
                                            scale: 1,
                                          },
                                          opts
                                        );
                                      item?.place?.categotyID === 1
                                        ? marker.setIcon(
                                            customIcon({
                                              fillColor: "#d2b48c",
                                              strokeColor: "white",
                                            })
                                          )
                                        : item?.place?.categotyID === 10
                                        ? marker.setIcon(
                                            customIcon({
                                              fillColor: "teal",
                                              strokeColor: "white",
                                            })
                                          )
                                        : item?.place?.categotyID === 5
                                        ? marker.setIcon(
                                            customIcon({
                                              fillColor: "turquoise",
                                              strokeColor: "white",
                                            })
                                          )
                                        : item?.place?.categotyID === 4
                                        ? marker.setIcon(
                                            customIcon({
                                              fillColor: "gold",
                                              strokeColor: "white",
                                            })
                                          )
                                        : item?.place?.categotyID === 2
                                        ? marker.setIcon(
                                            customIcon({
                                              fillColor: "#000080",
                                              strokeColor: "white",
                                            })
                                          )
                                        : item?.place?.categotyID === 7
                                        ? marker.setIcon(
                                            customIcon({
                                              fillColor: "#00ffff",
                                              strokeColor: "white",
                                            })
                                          )
                                        : item?.place?.categotyID === 9
                                        ? marker.setIcon(
                                            customIcon({
                                              fillColor: "tomato",
                                              strokeColor: "white",
                                            })
                                          )
                                        : item?.place?.categotyID === 12
                                        ? marker.setIcon(
                                            customIcon({
                                              fillColor: "wheat",
                                              strokeColor: "white",
                                            })
                                          )
                                        : marker.setIcon(
                                            customIcon({ fillColor: "green" })
                                          );
                                      return handleActiveMarker(marker, item);
                                    }}
                                  ></Marker>
                                </div>
                              ))}
                              {directionResponse && (
                                <DirectionsRenderer
                                  directions={directionResponse}
                                />
                              )}
                            </>
                          )}
                        </GoogleMap>
                      ) : (
                        <>
                          <GoogleMap
                            mapContainerStyle={containerStyle}
                            zoom={12}
                            center={center}
                          ></GoogleMap>
                        </>
                      )}
                      <div className="map_footer">
                        <Button
                          onClick={() => showPath()}
                          disabled={isShowPathDisabled()}
                        >
                          {showPathSpinner === true ? (
                            <Spinner size="sm"></Spinner>
                          ) : (
                            <>
                              <span>Show Path</span>
                              <span>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="11"
                                    stroke="#FFFFFF"
                                    strokeWidth="2"
                                  />
                                  <path
                                    d="M7.4375 6.9375H8.70312L15.8281 15.6719V6.9375H17.1172V18H15.9062L8.72656 9.20312V18H7.4375V6.9375Z"
                                    fill="#FFFFFF"
                                  />
                                  <path
                                    d="M7.4375 6.9375V6.4375H6.9375V6.9375H7.4375ZM8.70312 6.9375L9.09057 6.62145L8.94051 6.4375H8.70312V6.9375ZM15.8281 15.6719L15.4407 15.9879L16.3281 17.0758V15.6719H15.8281ZM15.8281 6.9375V6.4375H15.3281V6.9375H15.8281ZM17.1172 6.9375H17.6172V6.4375H17.1172V6.9375ZM17.1172 18V18.5H17.6172V18H17.1172ZM15.9062 18L15.5189 18.3162L15.6689 18.5H15.9062V18ZM8.72656 9.20312L9.11392 8.88697L8.22656 7.79974V9.20312H8.72656ZM8.72656 18V18.5H9.22656V18H8.72656ZM7.4375 18H6.9375V18.5H7.4375V18ZM7.4375 7.4375H8.70312V6.4375H7.4375V7.4375ZM8.31568 7.25355L15.4407 15.9879L16.2156 15.3558L9.09057 6.62145L8.31568 7.25355ZM16.3281 15.6719V6.9375H15.3281V15.6719H16.3281ZM15.8281 7.4375H17.1172V6.4375H15.8281V7.4375ZM16.6172 6.9375V18H17.6172V6.9375H16.6172ZM17.1172 17.5H15.9062V18.5H17.1172V17.5ZM16.2936 17.6838L9.11392 8.88697L8.3392 9.51928L15.5189 18.3162L16.2936 17.6838ZM8.22656 9.20312V18H9.22656V9.20312H8.22656ZM8.72656 17.5H7.4375V18.5H8.72656V17.5ZM7.9375 18V6.9375H6.9375V18H7.9375Z"
                                    fill="#FFFFFF"
                                  />
                                </svg>
                                <BsChevronRight
                                  size={20}
                                  className="right-arrow"
                                />
                              </span>
                            </>
                          )}
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              </div>

              {/* <Col className="order_1 my_route_left"> */}
              <div className="details_body">
                {isUserLoggedIn ? (
                  <>
                    {route_Detail?.length === 0 ? (
                      <NoDataFound />
                    ) : (
                      <div className="stepper">
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                          <Droppable
                            droppableId="route_Detail"
                            isDropDisabled={true}
                          >
                            {(provided) => (
                              <ul
                                className="route_Detail"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                key={0}
                              >
                                {route_Detail?.map((item, index) => {
                                  setItems(item);
                                  return (
                                    <>
                                      {item?.visited === true && (
                                        <Draggable
                                          key={index}
                                          isDragDisabled={true}
                                          draggableId={index.toString()}
                                          index={index}
                                        >
                                          {(provided) => (
                                            <Stepper
                                              className={
                                                item?.visited === true
                                                  ? "trip_comp trip"
                                                  : route_Detail?.length - 1 ===
                                                    index
                                                  ? "trip_end_point"
                                                  : item?.visited === false
                                                  ? "trip"
                                                  : ""
                                              }
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                            >
                                              <div className="stepper-wrapper">
                                                <Stepper.Step
                                                  style={{
                                                    margin: "0px 0px 0px 0px",
                                                  }}
                                                >
                                                  <Stepper.Content
                                                    style={{
                                                      margin: "0px 0px 0px 0px",
                                                    }}
                                                  >
                                                    <Card
                                                      body
                                                      style={{
                                                        margin:
                                                          "0px 0px 0px 0px",
                                                      }}
                                                    >
                                                      <div className="card_header">
                                                        {/* <Link to="/my-routes-detail">
                                                          <CardText>
                                                            {item?.place?.point}
                                                          </CardText>
                                                        </Link> */}
                                                        <div className="card_header_left">
                                                          <Dropdown
                                                            className="moreInfo"
                                                            toggle={() =>
                                                              setMenuOpen(
                                                                index ===
                                                                  dropdownMenuOpen
                                                                  ? null
                                                                  : index
                                                              )
                                                            }
                                                            isOpen={
                                                              index ===
                                                              dropdownMenuOpen
                                                            }
                                                          >
                                                            <DropdownToggle
                                                              onClick={() =>
                                                                getPreviousRoute(
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              <BiDotsVerticalRounded
                                                                size={20}
                                                              />
                                                            </DropdownToggle>
                                                            <DropdownMenu>
                                                              {item?.visited ===
                                                                true ||
                                                              index ===
                                                                0 ? null : (
                                                                <DropdownItem>
                                                                  <Link
                                                                    to="#"
                                                                    className="breadcrumb_item1"
                                                                    onClick={() =>
                                                                      addPointAbove(
                                                                        item
                                                                          ?.place
                                                                          ?.mkmID,
                                                                        "addPointAbove"
                                                                      )
                                                                    }
                                                                  >
                                                                    Add point
                                                                    above
                                                                  </Link>
                                                                </DropdownItem>
                                                              )}
                                                              {item?.visited ===
                                                                true ||
                                                              index ===
                                                                0 ? null : (
                                                                <DropdownItem>
                                                                  <div
                                                                    onClick={() =>
                                                                      previousRouteChange()
                                                                    }
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    route from
                                                                    previous
                                                                    point
                                                                  </div>
                                                                </DropdownItem>
                                                              )}
                                                              <DropdownItem
                                                                onClick={() =>
                                                                  addPointFromExploreNearBy(
                                                                    item?.place
                                                                      ?.poi,
                                                                    "exploreNearBy"
                                                                  )
                                                                }
                                                                className="breadcrumb_item1"
                                                              >
                                                                Explore near by
                                                              </DropdownItem>
                                                              <DropdownItem
                                                                onClick={() =>
                                                                  reportSuggestion(
                                                                    item?.place
                                                                      ?.title,
                                                                    item?.place
                                                                      ?.tzadikimID
                                                                      ? item
                                                                          ?.place
                                                                          ?.tzadikimID
                                                                      : item
                                                                          ?.place
                                                                          ?.mkmID
                                                                  )
                                                                }
                                                              >
                                                                Report
                                                                suggestion
                                                              </DropdownItem>
                                                            </DropdownMenu>
                                                          </Dropdown>
                                                          <Link
                                                            to="#"
                                                            onClick={() =>
                                                              deleteRoute(
                                                                item?.place
                                                                  ?.mkmID,
                                                                item?.place
                                                                  ?.title
                                                              )
                                                            }
                                                          >
                                                            <MdDelete
                                                              style={{
                                                                color: "red",
                                                              }}
                                                              size={18}
                                                            />
                                                          </Link>
                                                        </div>
                                                        <CardTitle className="distance">
                                                          {`Point-${index + 1}`}
                                                        </CardTitle>
                                                      </div>

                                                      <div
                                                        className="card_body"
                                                        onClick={() =>
                                                          viewDetails(
                                                            item?.place
                                                              ?.tzadikimID,
                                                            item?.place?.mkmID,
                                                            item?.place?.poi
                                                          )
                                                        }
                                                      >
                                                        {item?.place?.title}
                                                      </div>
                                                      <CardText className="text_card">
                                                        {item?.place?.cityY +
                                                          " "}{" "}
                                                        &nbsp;{" "}
                                                        {item?.place?.stateY}
                                                      </CardText>
                                                      <CardText className="location">
                                                        <TiLocation
                                                          style={{
                                                            color: "#618FFB",
                                                          }}
                                                        />
                                                        {item?.place?.cityE +
                                                          " "}{" "}
                                                        &nbsp;{" "}
                                                        {item?.place?.stateE}
                                                      </CardText>
                                                      <div className="card_footer">
                                                        <Button
                                                          onClick={() =>
                                                            viewDetails(
                                                              item?.place
                                                                ?.tzadikimID,
                                                              item?.place
                                                                ?.mkmID,
                                                              item?.place?.poi
                                                            )
                                                          }
                                                          className="btn viewdetail"
                                                        >
                                                          View Details
                                                        </Button>

                                                        <Link
                                                          to="#"
                                                          className="btn navigate"
                                                          onClick={() =>
                                                            NavigateClick(
                                                              item?.place?.poi
                                                            )
                                                          }
                                                        >
                                                          <IoNavigateSharp />
                                                          Navigate
                                                        </Link>
                                                        {!item?.visited ? (
                                                          <Link
                                                            to="#"
                                                            className="btn mark_visited"
                                                            onClick={() =>
                                                              markAsVisited(
                                                                item?.orderNumber,
                                                                item?.place
                                                                  ?.title
                                                              )
                                                            }
                                                          >
                                                            Mark as Visited
                                                          </Link>
                                                        ) : (
                                                          <Link
                                                            to="#"
                                                            className="btn mark_unvisited"
                                                            onClick={() =>
                                                              markAsNotVisited(
                                                                item?.orderNumber,
                                                                item?.place
                                                                  ?.title
                                                              )
                                                            }
                                                          >
                                                            Mark as Unvisited
                                                          </Link>
                                                        )}
                                                      </div>
                                                    </Card>
                                                  </Stepper.Content>
                                                </Stepper.Step>
                                                {/* <Stepper.Step key="step-2"></Stepper.Step> */}
                                              </div>
                                            </Stepper>
                                          )}
                                        </Draggable>
                                      )}
                                    </>
                                  );
                                })}
                                {provided.placeholder}
                              </ul>
                            )}
                          </Droppable>
                        </DragDropContext>
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                          <Droppable droppableId="route_Detail">
                            {(provided) => (
                              <ul
                                className="route_Detail"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                key={1}
                              >
                                {route_Detail?.map((item, index) => {
                                  setItems(item);
                                  return (
                                    <>
                                      {item?.visited === false && (
                                        <Draggable
                                          key={index}
                                          draggableId={index.toString()}
                                          index={index}
                                        >
                                          {(provided) => (
                                            <Stepper
                                              className={
                                                item?.visited === true
                                                  ? "trip_comp trip"
                                                  : route_Detail?.length - 1 ===
                                                    index
                                                  ? "trip_end_point"
                                                  : item?.visited === false
                                                  ? "trip"
                                                  : ""
                                              }
                                              style={{
                                                background: item?.visited
                                                  ? "greenyellow"
                                                  : "red",
                                              }}
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                            >
                                              <Stepper.Step
                                                style={{
                                                  margin: "0px 0px 0px 0px",
                                                }}
                                              >
                                                <Stepper.Content
                                                  style={{
                                                    margin: "0px 0px 0px 0px",
                                                  }}
                                                >
                                                  <Card
                                                    body
                                                    style={{
                                                      margin: "0px 0px 0px 0px",
                                                    }}
                                                  >
                                                    <div className="card_header">
                                                      {/* <Link to="/my-routes-detail">
                                                          <CardText>
                                                            {item?.place?.point}{" "}
                                                          </CardText>
                                                        </Link> */}
                                                      <div className="card_header_left">
                                                        <Dropdown
                                                          className="moreInfo"
                                                          toggle={() =>
                                                            setMenuOpen(
                                                              index ===
                                                                dropdownMenuOpen
                                                                ? null
                                                                : index
                                                            )
                                                          }
                                                          isOpen={
                                                            index ===
                                                            dropdownMenuOpen
                                                          }
                                                        >
                                                          <DropdownToggle
                                                            onClick={() =>
                                                              getPreviousRoute(
                                                                index
                                                              )
                                                            }
                                                          >
                                                            <BiDotsVerticalRounded
                                                              size={25}
                                                            />
                                                          </DropdownToggle>
                                                          <DropdownMenu>
                                                            {item?.visited ===
                                                              true ||
                                                            index ===
                                                              0 ? null : (
                                                              <DropdownItem>
                                                                <Link
                                                                  to="#"
                                                                  className="breadcrumb_item1"
                                                                  onClick={() =>
                                                                    addPointAbove(
                                                                      item
                                                                        ?.place
                                                                        ?.mkmID,
                                                                      "addPointAbove"
                                                                    )
                                                                  }
                                                                >
                                                                  Add point
                                                                  above
                                                                </Link>
                                                              </DropdownItem>
                                                            )}
                                                            {item?.visited ===
                                                              true ||
                                                            index ===
                                                              0 ? null : (
                                                              <DropdownItem>
                                                                <div
                                                                  onClick={() =>
                                                                    previousRouteChange()
                                                                  }
                                                                  className="breadcrumb_item1"
                                                                >
                                                                  Along the
                                                                  route from
                                                                  previous point
                                                                </div>
                                                              </DropdownItem>
                                                            )}
                                                            <DropdownItem
                                                              onClick={() =>
                                                                addPointFromExploreNearBy(
                                                                  item?.place
                                                                    ?.poi,
                                                                  "exploreNearBy"
                                                                )
                                                              }
                                                              className="breadcrumb_item1"
                                                            >
                                                              Explore near by
                                                            </DropdownItem>
                                                            <DropdownItem
                                                              onClick={() =>
                                                                reportSuggestion(
                                                                  item?.place
                                                                    ?.title,
                                                                  item?.place
                                                                    ?.tzadikimID
                                                                    ? item
                                                                        ?.place
                                                                        ?.tzadikimID
                                                                    : item
                                                                        ?.place
                                                                        ?.mkmID
                                                                )
                                                              }
                                                            >
                                                              Report suggestion
                                                            </DropdownItem>
                                                          </DropdownMenu>
                                                        </Dropdown>
                                                        <Link
                                                          to="#"
                                                          onClick={() =>
                                                            deleteRoute(
                                                              item?.place
                                                                ?.mkmID,
                                                              item?.place?.title
                                                            )
                                                          }
                                                        >
                                                          <MdDelete
                                                            style={{
                                                              color: "red",
                                                            }}
                                                            size={22}
                                                          />
                                                        </Link>
                                                      </div>
                                                      <CardTitle className="distance">
                                                        {`Point-${index + 1}`}
                                                      </CardTitle>
                                                    </div>

                                                    <div
                                                      className="card_body"
                                                      onClick={() =>
                                                        viewDetails(
                                                          item?.place
                                                            ?.tzadikimID,
                                                          item?.place?.mkmID,
                                                          item?.place?.poi
                                                        )
                                                      }
                                                    >
                                                      {item?.place?.title}
                                                    </div>
                                                    <CardText className="text_card">
                                                      {item?.place?.cityY + " "}{" "}
                                                      &nbsp;{" "}
                                                      {item?.place?.stateY}
                                                    </CardText>
                                                    <CardText className="location">
                                                      <TiLocation
                                                        style={{
                                                          color: "#618FFB",
                                                        }}
                                                      />
                                                      {item?.place?.cityE + " "}{" "}
                                                      &nbsp;{" "}
                                                      {item?.place?.stateE}
                                                    </CardText>
                                                    {/* {item?.visited === true || index === 0 ? <></> : <>
                                                                                                    <CardText className='distance'>
                                                                                                        Distance travelled from {`Point-${index}`} - &nbsp;
                                                                                                        {(item?.distance) ?
                                                                                                            <span>{item?.distance}</span> :
                                                                                                            <>
                                                                                                                <span id={`Tooltip-${index}`}><MdOutlineWatchLater /></span>
                                                                                                                <Tooltip
                                                                                                                    placement="top"
                                                                                                                    isOpen={isToolTipOpen(`Tooltip-${index}`)}
                                                                                                                    autohide={false}
                                                                                                                    target={`Tooltip-${index}`}
                                                                                                                    toggle={() => toggleTooltip(`Tooltip-${index}`)}
                                                                                                                >To get ETA, please click on the Refresh button.</Tooltip>
                                                                                                            </>
                                                                                                        }
                                                                                                    </CardText>
                                                                                                </>} */}
                                                    <div className="card_footer">
                                                      <Button
                                                        onClick={() =>
                                                          viewDetails(
                                                            item?.place
                                                              ?.tzadikimID,
                                                            item?.place?.mkmID,
                                                            item?.place?.poi
                                                          )
                                                        }
                                                        className="btn viewdetail"
                                                      >
                                                        View Details
                                                      </Button>
                                                      <Link
                                                        to="#"
                                                        className="btn navigate"
                                                        onClick={() =>
                                                          NavigateClick(
                                                            item?.place?.poi
                                                          )
                                                        }
                                                      >
                                                        <IoNavigateSharp />
                                                        Navigate
                                                      </Link>

                                                      {!item?.visited ? (
                                                        <Link
                                                          to="#"
                                                          className="btn mark_visited"
                                                          onClick={() =>
                                                            markAsVisited(
                                                              item?.orderNumber,
                                                              item?.place?.title
                                                            )
                                                          }
                                                        >
                                                          Mark as Visited
                                                        </Link>
                                                      ) : (
                                                        <Link
                                                          to="#"
                                                          className="btn mark_unvisited"
                                                          onClick={() =>
                                                            markAsNotVisited(
                                                              item?.orderNumber,
                                                              item?.place?.title
                                                            )
                                                          }
                                                        >
                                                          Mark as Unvisited
                                                        </Link>
                                                      )}
                                                    </div>
                                                  </Card>
                                                </Stepper.Content>
                                              </Stepper.Step>
                                              {/* <Stepper.Step key="step-2"></Stepper.Step> */}
                                            </Stepper>
                                          )}
                                        </Draggable>
                                      )}
                                    </>
                                  );
                                })}
                                {provided.placeholder}
                              </ul>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </div>
                    )}
                  </>
                ) : (
                  <UserNotLoggedIn />
                )}
              </div>
              {/* </Col> */}
            </div>
          </Container>
        </div>
      </Container>
    </div>
  );
}

export default Routes_Detail;
